/* @sravni/react-design-system version 0.2.60 */
import * as React from 'react';

var SizeContext = React.createContext(undefined);
var SizeContextProvider = function (_a) {
    var children = _a.children, size = _a.size;
    return (React.createElement(SizeContext.Consumer, null, function (originSize) { return React.createElement(SizeContext.Provider, { value: size || originSize }, children); }));
};

export default SizeContext;
export { SizeContextProvider };
//# sourceMappingURL=SizeContext.js.map
